// Phone diagnostics (opt-in: open the game with ?diag=1; it sticks for the tab). An iPhone tab
// that runs out of memory dies without an error the page could report, so every 3 s this sends
// a snapshot to POST /api/diag (backend routers/diag.py logs it) — the last lines before the
// gap show what was growing. ?diag=0 turns it off again.
import { API_URL } from '../config.js';

function snapshot(game, t0, taps) {
  const tm = game.textures;
  let img = 0, canv = 0, n = 0;
  for (const k of tm.getTextureKeys()) for (const s of tm.get(k).source) { n++; const px = s.width * s.height * 4; if (s.isCanvas) canv += px; else img += px; }
  let objs = 0;
  const walk = (list) => { for (const o of list) { objs++; if (o.list) walk(o.list); } };
  const scenes = game.scene.getScenes(true);
  for (const sc of scenes) walk(sc.sys.displayList.list);
  const tweens = scenes.reduce((a, sc) => a + (sc.tweens?.getTweens?.().length ?? 0), 0);
  const timers = scenes.reduce((a, sc) => a + (sc.time?._active?.length ?? 0), 0);
  const snd = game.sound?.sounds ?? [];
  const mem = performance.memory ? Math.round(performance.memory.usedJSHeapSize / 1e6) : null;
  return {
    t: Math.round((performance.now() - t0) / 1000), scene: scenes.map((s) => s.scene.key).filter((k) => k !== 'PreloadScene').join('+'),
    texMB: Math.round(img / 1e6), canvasMB: Math.round(canv / 1e6), textures: n, objs, tweens, timers,
    sounds: snd.length, playing: snd.filter((s) => s.isPlaying).length, audio: game.sound?.context?.state ?? null,
    music: `${game.cache.audio.exists('music_loop') ? 'cached' : 'not-cached'}/${snd.some((s) => s.key === 'music_loop' && s.isPlaying) ? 'playing' : 'silent'}/${game.sound?.locked ? 'locked' : 'unlocked'}/${(() => { try { return localStorage.getItem('sd_music_muted') === '1' ? 'muted' : 'on'; } catch { return '?'; } })()}`,
    session: navigator.audioSession?.type ?? null,
    heapMB: mem, taps, dom: document.getElementsByTagName('*').length,
    vw: innerWidth, vh: innerHeight, dpr: devicePixelRatio, canvas: `${game.canvas.width}x${game.canvas.height}`,
    root: Math.round(document.getElementById('game-root')?.getBoundingClientRect().height ?? 0),
    cssCanvas: (() => { const r = game.canvas.getBoundingClientRect(); return `${Math.round(r.width)}x${Math.round(r.height)}@${Math.round(r.top)}`; })(),
    vv: window.visualViewport ? `${Math.round(visualViewport.width)}x${Math.round(visualViewport.height)}+${Math.round(visualViewport.offsetTop)}` : null,
  };
}

export function installDiagBeacon(game) {
  let on = false;
  try {
    const q = new URLSearchParams(location.search).get('diag');
    if (q === '1') sessionStorage.setItem('sd_diag', '1');
    if (q === '0') sessionStorage.removeItem('sd_diag');
    on = sessionStorage.getItem('sd_diag') === '1';
  } catch { on = false; }
  if (!on) return;
  const t0 = performance.now();
  let taps = 0, first = true;
  addEventListener('pointerdown', () => { taps++; }, { capture: true, passive: true });
  const send = (extra = {}) => {
    if (!window.__myId && !first) return;       // logged-in players only (the endpoint needs the cookie)
    const body = { ...snapshot(game, t0, taps), ...extra, ...(first ? { ua: navigator.userAgent } : {}) };
    first = false;
    try { navigator.sendBeacon(`${API_URL}/api/diag`, JSON.stringify(body)); } catch { /* best effort */ }
  };
  setInterval(send, 3000);
  addEventListener('pagehide', () => send({ event: 'pagehide' }));
  document.addEventListener('visibilitychange', () => send({ event: document.visibilityState }));
}
